import * as DOMPurify from 'isomorphic-dompurify';

export const sanitize = (content: string): string => DOMPurify.sanitize(content, { ADD_ATTR: ['target'] });
